import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { feesAPI } from '../../services/feesService';
import PaymentInvoice from './PaymentInvoice';

const PaymentHistoryTable = ({ studentFeeId, onPrint }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const res = await feesAPI.getPaymentHistory(studentFeeId);
        if (res?.data?.success) {
          setHistory(res.data.data || []);
        }
      } catch (err) {
        console.error('fetchHistory error', err);
      } finally {
        setLoading(false);
      }
    };
    fetchHistory();
  }, [studentFeeId]);


  if (loading) return <div className="p-2 text-xs italic text-gray-500">Loading payment history...</div>;
  if (history.length === 0) return <div className="p-2 text-xs italic text-gray-500">No payment history found.</div>;

  return (
    <>
      <DataTable value={history} className="p-datatable-sm p-datatable-gridlines text-xs shadow-sm" responsiveLayout="scroll">
        {/* <Column field='id' header="Receipt Id" body={(row) => row.id || 'N/A'} /> */}
        <Column field="paidAmount" header="Paid Amount" body={(row) => `₹${Number(row.paidAmount || 0).toLocaleString()}`} />
        <Column field="paymentMode" header="Mode" body={(row) => row.paymentMode || 'N/A'} />
        <Column field="paidAt" header="Paid At" body={(row) => row.paidAt ? new Date(row.paidAt).toLocaleString() : 'N/A'} />
        <Column header="Receipt" body={(row) => (
          <Button icon="pi pi-download" className="p-button-rounded p-button-text p-button-sm text-blue-600" onClick={() => onPrint(row.id)}
            tooltip="Download Receipt" tooltipOptions={{ position: 'top' }} />
        )} className="text-center" style={{ width: '80px' }} />
      </DataTable>
    </>
  );
};

const FeeDetails = ({
  student,
  fees,
  feeLoading,
  handleBackToStudentsTable,
  handlePayFee,
  expandedRows,
  setExpandedRows,
  showingContainer
}) => {
  const [paymentHistoryId, setPaymentHistoryId] = useState(null);
  const handlePrint = () => {
    if (!paymentHistoryId) return;
    window.print();
    // Clear after a delay to ensure print preview has finished
    setTimeout(() => setPaymentHistoryId(null), 500);
  };
  const feeAmountTemplate = (row) => (
    <div className="text-sm font-semibold text-green-600">
      ₹{Number(row.amount || 0).toLocaleString()}
    </div>
  );

  const feePayableAmountTemplate = (row) => (
    <div className="text-sm font-semibold text-green-600">
      ₹{Number(row.payableAmount || 0).toLocaleString()}
    </div>
  );

  const feeStatusTemplate = (row) => {
    const status = row.status || 'pending';
    const statusConfig = {
      paid: { color: 'bg-green-100 text-green-800', icon: 'pi-check-circle' },
      partial: { color: 'bg-yellow-100 text-yellow-800', icon: 'pi-clock' },
      pending: { color: 'bg-red-100 text-red-800', icon: 'pi-exclamation-triangle' }
    };

    const config = statusConfig[status] || statusConfig.pending;

    return (
      <div className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${config.color}`}>
        <i className={`pi ${config.icon} mr-1`}></i>
        {status.charAt(0).toUpperCase() + status.slice(1)}
      </div>
    );
  };

  const feeActionsTemplate = (row) => (
    <div className="flex items-center justify-center space-x-2">
      {/* <Button icon="pi pi-dollar" className="p-button-rounded p-button-text p-button-sm hover:bg-yellow-50 text-yellow-600 border-2 border-yellow-200 hover:border-yellow-300 transition-all duration-200" onClick={() => handlePayFee(row)} tooltip="Fee Details" tooltipOptions={{ position: 'top' }} /> */}
      <Button label="₹" onClick={() => handlePayFee(row)} tooltip="Pay Fee" tooltipOptions={{ position: 'top' }}
        className=" w-10 h-10  rounded-full  flex items-center justify-center  bg-yellow-500 hover:bg-yellow-600  text-white font-semibold  shadow-md  transition-all duration-200" />

    </div>
  );

  const rowExpansionTemplate = (data) => {
    return (
      <div className="p-3 bg-gray-50 rounded-lg shadow-inner m-2 border border-gray-200">
        <h5 className="text-sm font-bold text-gray-800 mb-3 flex items-center">
          <i className="pi pi-history mr-2 text-indigo-500"></i>
          Payment History for {data.feeType}
        </h5>
        <PaymentHistoryTable studentFeeId={data.id} onPrint={(historyId) => setPaymentHistoryId(historyId)} />
      </div>
    );
  };

  return (
    <div className="flex-1 overflow-auto bg-gradient-to-br from-green-50 via-emerald-50/30 to-teal-50/50 p-2">
     { showingContainer == false &&
      <div className="flex items-center justify-between mb-4">
        <button onClick={handleBackToStudentsTable} className="px-4 py-2 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg hover:from-green-700 hover:to-emerald-700 transition-all duration-300 flex items-center gap-2 font-semibold shadow-lg hover:shadow-xl text-sm">
          <i className="pi pi-arrow-left text-xs"></i> Back to Students
        </button>
        <h6 className="flex items-center justify-between mb-4">{student.firstName} , {student.className} , ADNO:{student.admissionNumber}  </h6>

      </div>}

      <div className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/20 overflow-hidden">
        {feeLoading ? (
          <div className="flex justify-center items-center py-12">
            <div className="flex flex-col items-center space-y-2">
              <div className="w-12 h-12 border-4 border-green-200 border-t-green-600 rounded-full animate-spin"></div>
              <p className="text-sm font-medium text-gray-700">Loading fee details...</p>
            </div>
          </div>
        ) : (
          <DataTable value={fees} paginator rows={5} emptyMessage="No fee records found" className="p-datatable-striped p-datatable-gridlines" responsiveLayout="scroll"
            expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)} rowExpansionTemplate={rowExpansionTemplate} dataKey="id">
            <Column expander style={{ width: '3em' }} />
            <Column field="feeType" header="Fee Type" sortable style={{ minWidth: '120px' }} />
            <Column field="description" header="Description" style={{ minWidth: '200px' }} />
            <Column header="Amount" body={feeAmountTemplate} sortable style={{ minWidth: '100px' }} />
            <Column header="Pay Amount" body={feePayableAmountTemplate} sortable style={{ minWidth: '100px' }} />
            <Column header="Status" body={feeStatusTemplate} sortable style={{ minWidth: '100px' }} />
            <Column header="Actions" body={feeActionsTemplate} sortable style={{ minWidth: '100px' }} />
          </DataTable>
        )}
      </div>
      <div className="printable-content hidden print:block">
        {paymentHistoryId && (
          <PaymentInvoice paymentHistoryId={paymentHistoryId} onDataLoaded={handlePrint} />
        )}
      </div>
    </div>
  );
};

export default FeeDetails;
